<template>
  <div class="pvscan-container">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product-pvs-banner.png"
        class="pc-banner"
        alt=""
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_scanner_banner_mobile.png"
        class="mobile-banner"
        alt=""
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          光伏一点通-分布式巡检平台
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          明察秋毫 尽在掌握
        </div>
        <div
          class="use-button wow fadeInUp"
          data-wow-delay="0.7s"
          @click="openCodeDialog"
        >
          申请试用
        </div>
      </div>
    </div>

    <div class="block-wrap" style="background-color: #f5f7fa">
      <div class="block-title page-block-title">产品简介</div>
      <div class="block-desc">
        依托焱图云平台，将巡检数据自动云端建模及缺陷分析，无需预先建模，重新定义巡检新形态。
      </div>
      <div class="content-wrap">
        <div class="product-row">
          <div class="product-column">
            <div class="top-img fly-block text-tips"></div>
            <div class="bottom-text">
              <div class="product-title">飞行巡检</div>
              <div class="product-desc">
                <div>使用无人机+巡检精灵APP，</div>
                <div>对目标区域进行飞行巡检</div>
              </div>
            </div>
          </div>

          <div class="product-column">
            <div class="top-img analysis-block"></div>
            <div class="bottom-text">
              <div class="product-title">智能分析</div>
              <div class="product-desc">
                <div>平台对无人机巡检的照片进行分</div>
                <div>析处理，识别各种问题及隐患</div>
              </div>
            </div>
          </div>

          <div class="product-column">
            <div class="top-img defect-block"></div>
            <div class="bottom-text">
              <div class="product-title">精准消缺</div>
              <div class="product-desc">
                <div>使用去消缺APP，</div>
                <div>导航定位缺陷并进行消缺处理。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平台功能 -->
    <div class="block-wrap">
      <div class="block-title page-block-title">主要功能</div>
      <div class="block-content mobile-function">
        <mobileCarousel></mobileCarousel>
      </div>
      <div class="block-content pc-function">
        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img8.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">镜头垂直光伏组件</div>
              <div class="desc">
                无人机镜头垂直于光伏板，确保捕捉到光伏板的完整、正面视图，从而能够更准确地拍摄到光伏板的表面情况，如是否有污垢、损坏或其他异常情况。
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">无需预先建模</div>
              <div class="desc">
                将无人机巡检的照片上传云平台，平台自动云端建模并进行缺陷分析。
              </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img9.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img10.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">组件自动编号</div>
              <div class="desc">
                根据电站项目的分布，可将电站分区管理，基于组件所在的区域，再结合具体的行列定位，对组件进行编号。
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">可见光+热红外双光识别</div>
              <div class="desc">
                将可见光和热红外识别技术结合用于光伏板缺陷检测，能够同时实现光伏板表面和内部缺陷的高效、准确识别。可识别的缺陷类别包括：点状热斑、全红热斑、横条状热斑、竖条状热斑、厚积尘、遮挡、鸟粪和破损。
              </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img11.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img12.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">自动生成报告</div>
              <div class="desc">
                类型缺陷数量统计图表、电站地图、缺陷分布 、缺陷组件详细信息等。
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">自动定位故障并导航</div>
              <div class="desc">
                使用去消缺APP，选择具体故障可自动定位该故障准确位置，并显示运维人员和故障间的路线，运维人员可直接导航到故障位置，节省了大量的时间。
              </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img13.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="codeDialogFlag">
      <codeCard
        @closeDialog="closeDialog"
        :codeDialogFlag="codeDialogFlag"
      ></codeCard>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import mobileCarousel from "./components/pvscan-mobile-carousel.vue";
import codeCard from "./components/inspection-code.vue";

export default {
  components: {
    mobileCarousel,
    codeCard,
  },
  data() {
    return {
      codeDialogFlag: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    closeDialog() {
      this.codeDialogFlag = false;
    },
    openCodeDialog() {
      this.codeDialogFlag = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
  .mask {
    width: 100%;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,0.7);
    display:flex;
    justify-content:center;
    z-index:15;
    align-items:center;
}
.pvscan-container {
    width:100%;
    @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
    .layout-banner {
        height:100vh;
        position:relative;
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:13%;
            transform: translateY(-50%);
            z-index: 2;
            color:#fff;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:625px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
            .use-button {
                width:9rem;
                height:2.875rem;
                cursor:pointer;
                font-size:1.125rem;
                letter-spacing:1px;
                background: #2372E9;
                line-height:2.875rem;
                text-align:center;
                margin-top:6.18rem;
                border-radius:30px;
            }
        }
    }
    .block-wrap {
        width:100%;
        position:relative;
        padding-top:4.625rem;
        .block-title {
            position:relative;
            position:relative;
            text-align:center;
            letter-spacing:2px;
            font-weight:bold;
        }
            .block-desc {
                margin:4.625rem auto 3.75rem;
                line-height:32px;
                font-size:1rem;
                color:#666666;
                text-align:center;
            }
    }
    .content-wrap {
        max-width:var(--main-width);
        width:84%;
        margin:0 auto;
        padding-bottom:5.8rem;
        text-align:center;
        img {
            width:1134px;
        }
        .product-row {
            display:flex;
            justify-content:space-between;
            margin-top:4.93rem;
            flex-wrap:wrap;
            .product-column {
                width:32%;
            }
            .top-img {
                background-color:#E6E6E6;
                height:13.56rem;
                background-repeat:no-repeat;
                background-position:center;
            }
            .fly-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img1.png");
                background-size:90%;
            }
            .analysis-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img2.png");
                background-size:cover;
            }
            .defect-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img3.png");
                background-size:cover;
            }
            .bottom-text {
                background-color:#fff;
                padding:1rem 0 1.8rem;
                .product-title {
                    margin-bottom:10px;
                    font-size:1.375rem;
                    font-weight:bold;
                }
                .product-desc {
                    color:#666666;
                    font-size:14px;
                    line-height:25px;
                    text-align:center;
                }
            }
        }
    }

    .block-content {
        max-width:var(--main-width);
        width:84%;
        margin:7.56rem auto 0;
        margin-top:7.56rem;
        .content-row {
            display:flex;
            margin-bottom:4rem;
            >div {
                flex:1;
            }
            .block-text {
                padding:3rem 5.5rem;
                .title {
                    color:#2372E9;
                    margin-bottom:3.18rem;
                    font-size:1.75rem;
                    font-weight:bold;
                }
                .desc {
                    color:#333333;
                    line-height:30px;
                    font-size:1rem;
                }
            }
        }
    }
    .mobile-function {
        display:none;
    }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
    .product-row {
        flex-wrap:wrap;
        .product-column {
            margin-bottom:30px;
        }
    }
    .content-row {
        flex-wrap:wrap;
        .img-wrap {
            height:425px;
            overflow:hidden;
            img {
                width:100%;
            }
        }
        .row-left,.row-right {
            width:100%;
            flex:auto !important;
        }
    }
}
@media only screen and (max-width: 768px) {
    .analysis-block {
        background-size:cover !important;
    }
    .block-content {
        width:100% !important;
    }

    .content-row {
        flex-wrap:wrap;
        .img-wrap {
            overflow:hidden;
            img {
                width:100%;
            }
        }
        .row-left,.row-right {
            width:100%;
            flex:auto !important;
        }
    }
    .pvscan-container {
    .layout-banner {
        height:380px;
        margin-top:108px;
        .text-block {
            transform:translateY(0);
            top:71px;
             .title {
            font-size:24px;
            margin-bottom:10px;
        }
        .desc {
              line-height:20px;
            }
        }
        .use-button {
            display:none;
        }
    }
    .content-wrap {
         .product-row {
        flex-wrap:wrap;
        justify-content:center;
        margin-top:0px;

        .product-column {
            margin:0 15px 30px;
            min-width:345px;
        }
    }
    }
     .block-wrap {
        padding:25px 15px 0;
        margin:0px;
        width:auto;
        .block-title {
            font-size:22px;
        }
        .block-title::after {
            top:40px !important;
        }
        .block-desc {
            width:auto;
            padding:0 15px;
            margin-top:38px;
            font-size:14px;
            margin-bottom:20px;
            line-height:20px;
        }
    }
    }

    .content-wrap {
        padding-bottom:1.8rem !important;
        width:auto !important;
    }

    .platform-bg {
        width:345px !important;
    }
    .block-content {
        margin-top:40px !important;
    }
    .pc-function {
        display:none !important;
    }
    .mobile-function {
        display:block !important
    }

}
</style>
